import {createSlice} from "@reduxjs/toolkit";
import {
    ChatStopReason,
    KAIResponseType,
    LocalStorageKeys,
    LowScoreMessage,
    NoAnswerMessage,
    NoSourcesMessage,
    StreamErrorMessage,
} from "../../types";
import {readLocalStorageValue} from "@mantine/hooks";
import {chatApi} from "./chatApi";

type State = {
    threadId?: string;
    error?: StreamErrorMessage;
    rateLimitCount: number;
    stopReason?: ChatStopReason;
    lowScoreMessage?: LowScoreMessage;
    noAnswerMessage?: NoAnswerMessage;
    noSourcesMessage?: NoSourcesMessage;
};

const initialState: State = {
    threadId: "",
    rateLimitCount: 0,
};

const transientChatSlice = createSlice({
    name: "transientChat",
    initialState,
    reducers: {
        initiateTransientStore(state, action) {
            state.threadId = action.payload;
        },

        addStreamError(state, action) {
            state.error = action.payload;
            state.rateLimitCount = state.rateLimitCount + 1;
        },
        setStopReason(state, action) {
            state.stopReason = action.payload;
        },
        clearTransientStore(state) {
            state.threadId = "";
            state.error = undefined;
            state.stopReason = undefined;
            state.rateLimitCount = 0;
            state.lowScoreMessage = undefined;
            state.noAnswerMessage = undefined;
            state.noSourcesMessage = undefined;
        },
        addLowScoreMessage(state, action) {
            state.lowScoreMessage = action.payload;
        },
        addNoAnswerMessage(state, action) {
            state.noAnswerMessage = action.payload;
        },
        addNoSourcesMessage(state, action) {
            state.noSourcesMessage = action.payload;
        },
        clearKaiPlusSuggestionMessage(state, action) {
            if (state.lowScoreMessage?.messageId === action.payload) {
                state.lowScoreMessage = undefined;
            }
            if (state.noAnswerMessage?.messageId === action.payload) {
                state.noAnswerMessage = undefined;
            }
            if (state.noSourcesMessage?.messageId === action.payload) {
                state.noSourcesMessage = undefined;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            chatApi.endpoints.sendMessage.matchPending,
            (state, action) => {
                state.threadId = "";
                state.error = undefined;
                state.stopReason = undefined;
                state.rateLimitCount = 0;
                state.lowScoreMessage = undefined;
                state.noAnswerMessage = undefined;
                state.noSourcesMessage = undefined;
            }
        );
    },
});

export const {
    initiateTransientStore,
    addStreamError,
    setStopReason,
    addLowScoreMessage,
    addNoAnswerMessage,
    addNoSourcesMessage,
    clearKaiPlusSuggestionMessage,
    clearTransientStore,
} = transientChatSlice.actions;

export default transientChatSlice.reducer;
